// Global functions which are called from save user card/bank iframes and mobile app(?) to retrieve credit card/bank account information
var creditCardInfo = {};
var __getCreditCardInfo = function() {
    return JSON.stringify(creditCardInfo);
};

var __setCreditCardInfo = function(data) {
    creditCardInfo = data;
};

window.__getCreditCardInfo = __getCreditCardInfo;
window.__setCreditCardInfo = __setCreditCardInfo;

var bankAccountInfo = {};
var __setBankAccountInfo = function(data) {
    bankAccountInfo = data;
};

var __getBankAccountInfo = function() {
    return JSON.stringify(bankAccountInfo);
};

window.__setBankAccountInfo = __setBankAccountInfo;
window.__getBankAccountInfo = __getBankAccountInfo;

// Module imports loaded by their dependencies - do not change the ordering...
import './payment/jquery.cardswipe';
import './payment/jquery.i4goTrueToken.1.0.0';
import './payment/magstripe';
import './payment/cashflow';
import './payment/I4go';
import './payment/IDTech';
import './payment/TakePayment';
import './payment/EmvTerminal';
import './payment/PaymentController';
import './payment/cardConnect';

import {
    cardConnectFrameDialogServiceBillingInfo, cardConnectFrameDialogServiceRefund
} from './payment/CardConnect/cardConnectFrameDialogForm';
import cardConnectIframeDialogMembershipBillingInformation from './payment/CardConnect/cardConnectIframeDialogMembershipBillingInformation';
import cardConnectIframeSaveUserCard from './payment/CardConnect/cardConnectFrameSaveUserCard';
import CardConnectTakePayment from './payment/CardConnect/CardConnectTakePayment';
import {
    i4goFrameDialogServiceBillingInfo, i4goFrameDialogServiceRefund
} from './payment/i4go-frame/I4goFrameDialogForm';
import I4goIframeDialogCardIsExpired from './payment/i4go-frame/I4goIframeDialogCardIsExpired';
import I4goIframeDialogMembershipBillingInformation from './payment/i4go-frame/I4goIframeDialogMembershipBillingInformation';
import I4goIframeSaveUserCard from './payment/i4go-frame/I4goFrameSaveUserCard';
import i4goIframeTakePayment from './payment/i4go-frame/I4goFrameTakePayment';
import {
    CashFlowFrameDialogServiceBillingInfo, CashFlowFrameDialogServiceRefund
} from './payment/CashFlow/cashFlowFrameDialogForm';
import {
    CashFlowFrameDialogServiceBillingInfoBank, CashFlowFrameDialogServiceRefundBank
} from './payment/CashFlow/cashFlowFrameDialogFormBank';
import cashFlowIframeDialogMembershipBillingInformation from './payment/CashFlow/cashFlowIframeDialogMembershipBillingInformation';
import cashFlowIframeDialogMembershipBillingInformationBank from './payment/CashFlow/cashFlowIframeDialogMembershipBillingInformationBank';
import cashFlowShoppingCart from './payment/CashFlow/cashFlowShoppingCart';
import cashFlowPayMyBill from './payment/CashFlow/cashFlowPayMyBill';
import CashFlowTakePayment from './payment/CashFlow/CashFlowTakePayment';
import cashFlowIframeSaveUserCard from './payment/CashFlow/cashFlowFrameSaveUserCard';
import cashFlowIframeSaveUserBank from './payment/CashFlow/cashFlowFrameSaveUserBank';

// globals
window.cardConnectFrameDialogServiceBillingInfo = cardConnectFrameDialogServiceBillingInfo;
window.cardConnectFrameDialogServiceRefund = cardConnectFrameDialogServiceRefund;
window.cardConnectIframeDialogMembershipBillingInformation = cardConnectIframeDialogMembershipBillingInformation;
window.cardConnectIframeSaveUserCard = cardConnectIframeSaveUserCard;
window.CardConnectTakePayment = CardConnectTakePayment;
window.cashFlowFrameDialogServiceBillingInfo = new CashFlowFrameDialogServiceBillingInfo();
window.cashFlowFrameDialogServiceRefund = new CashFlowFrameDialogServiceRefund();
window.cashFlowFrameDialogServiceBillingInfoBank = new CashFlowFrameDialogServiceBillingInfoBank();
window.cashFlowFrameDialogServiceRefundBank = new CashFlowFrameDialogServiceRefundBank();
window.cashFlowIframeDialogMembershipBillingInformation = cashFlowIframeDialogMembershipBillingInformation;
window.cashFlowIframeDialogMembershipBillingInformationBank = cashFlowIframeDialogMembershipBillingInformationBank;
window.cashFlowShoppingCart = cashFlowShoppingCart;
window.cashFlowPayMyBill = cashFlowPayMyBill;
window.cashFlowTakePayment = new CashFlowTakePayment();
window.i4goFrameDialogServiceBillingInfo = i4goFrameDialogServiceBillingInfo;
window.i4goFrameDialogServiceRefund = i4goFrameDialogServiceRefund;
window.I4goIframeDialogCardIsExpired = I4goIframeDialogCardIsExpired;
window.I4goIframeDialogMembershipBillingInformation = I4goIframeDialogMembershipBillingInformation;
window.i4goIframeSaveUserCard = I4goIframeSaveUserCard;
window.i4goIframeTakePayment = i4goIframeTakePayment;
window.cashFlowIframeSaveUserCard = cashFlowIframeSaveUserCard;
window.cashFlowIframeSaveUserBank = cashFlowIframeSaveUserBank;

import '../styles/payment/take-payment.css';
